import { SvgLogo } from "ui/svgs";
import clsx from "clsx";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { showToast } from "ui/components/common";
import usePresetRtcService from "ui/preset/service";
import { SvgAlertPrevPage, SvgAlertNextPage } from "ui/svgs";
import ItemSlide from "./itemSlide";
import type { presetGuardPicType } from "./itemSlide";

export default function PresetGuardPicSlide(props: {
  data: presetGuardPicType[];
  pause: boolean;
  currentPicId: string;
  setCurrentPicId: (eventId: string) => void;
  onAllLoaded?: (arr: { eventId: string; src: string }[]) => void;
}) {
  const { data, pause, currentPicId, setCurrentPicId, onAllLoaded } = props;
  const pageRef = useRef<HTMLDivElement>(null);
  const [leftArrowEnable, setLeftArrowEnable] = useState(false);
  const [rightArrowEnable, setRightArrowEnable] = useState(false);
  const [loadedPic, setLoadedPic] = useState<Map<string, string>>(new Map());
  const keyPressRef = useRef(false);
  const keyTimerRef = useRef(null);

  const handleResize = () => {
    handleScroll();
  };

  useEffect(() => {
    handleScroll();
    return () => {
      setLoadedPic(new Map());
    };
  }, [data]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (loadedPic.size === data.length && data.length > 0) {
      const objArray = Array.from(loadedPic, ([key, value]) => ({
        eventId: key,
        src: value,
      }));
      onAllLoaded(objArray);
    }
  }, [loadedPic]);

  const updatePicArrowBtnEnable = (newScrollLeft) => {
    setLeftArrowEnable(newScrollLeft > 0);
    setRightArrowEnable(
      newScrollLeft + pageRef?.current?.clientWidth <
        pageRef?.current?.scrollWidth - 1,
    );
  };

  const handlePicPageScrollLeft = () => {
    const newScrollLeft = Math.max(pageRef?.current?.scrollLeft - 100, 0);
    pageRef?.current?.scrollTo({
      left: newScrollLeft,
    });
    handleScroll();
  };

  const handlePicPageScrollRight = () => {
    console.log("first scrollLeft", pageRef.current.scrollLeft);
    const newScrollLeft = Math.max(pageRef?.current?.scrollLeft + 100, 0);

    pageRef?.current?.scrollTo({
      left: newScrollLeft,
    });
    handleScroll();
  };

  const handleScroll = () => {
    console.log("handleScroll", pageRef.current.scrollLeft);
    updatePicArrowBtnEnable(pageRef.current.scrollLeft);
  };

  const handleWheel = (e) => {
    if (e.deltaY > 0) {
      handlePicPageScrollRight();
    } else {
      handlePicPageScrollLeft();
    }
  };

  const onCurrentPicIdChange = useCallback((eventId) => {
    setCurrentPicId(eventId);
  }, []);

  const onOneLoaded = useCallback((eventId, src) => {
    setLoadedPic((pre) => {
      pre.set(eventId, src);
      return new Map(pre);
    });
  }, []);

  const handleMouseUp = (e) => {
    // setIsMousePressed(false);

    keyPressRef.current = false;
    clearInterval(keyTimerRef.current);
  };

  const handleMouseDown = (direction: string) => {
    if (keyPressRef.current) {
      return;
    }
    if (direction === "right") {
      keyPressRef.current = true;
      keyTimerRef.current = setInterval(() => {
        handlePicPageScrollRight();
      }, 300);
      handlePicPageScrollRight();
    } else if (direction === "left") {
      keyPressRef.current = true;
      keyTimerRef.current = setInterval(() => {
        handlePicPageScrollLeft();
      }, 300);
      handlePicPageScrollLeft();
    }
  };

  return (
    <div className="flex relative items-center gap-1">
      <button
        disabled={!leftArrowEnable || !pause}
        className={clsx(
          "w-6 h-[72px] bg-[#E1E1E1] flex rounded-s-2xl items-center justify-center disabled:hover:bg-[#E1E1E1] hover:bg-[#dcdcdc] disabled:fill-slate-400 fill-[#222222]",
        )}
        //onClickCapture={handlePicPageScrollLeft}
        onMouseDown={() => handleMouseDown("left")}
        onMouseUp={handleMouseUp}
      >
        <SvgAlertPrevPage width="14" />
      </button>

      <div
        className="flex gap-2 h-full w-full max-w-full overflow-x-hidden"
        style={{ scrollSnapType: "x mandatory" }}
        ref={pageRef}
        onScroll={handleScroll}
        onWheel={handleWheel}
      >
        {data?.map((item) => {
          const isActive = item.eventId === currentPicId;
          return (
            <ItemSlide
              data={item}
              isActive={isActive}
              pause={pause}
              setCurrentPicId={onCurrentPicIdChange}
              onLoaded={onOneLoaded}
            />
          );
        })}
      </div>
      <button
        disabled={!rightArrowEnable || !pause}
        className={clsx(
          "w-6 h-[72px] bg-[#E1E1E1] flex rounded-r-2xl items-center justify-center disabled:hover:bg-[#E1E1E1] hover:bg-[#dcdcdc] disabled:fill-slate-400 fill-[#222222]",
        )}
        onMouseDown={() => handleMouseDown("right")}
        onMouseUp={handleMouseUp}
        // onClick={handlePicPageScrollRight}
      >
        <SvgAlertNextPage width="14" />
      </button>
    </div>
  );
}
